"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Pass in the booking company ID to get booking compony default values.
 * */
var bookingCompanies = exports.bookingCompanies = {
    1: {
        id: 1,
        name: "G Adventures",
        email: "experience@gadventures.com"
    },
    3: {
        id: 3,
        name: "Just You",
        email: ""
    },
    4: {
        id: 4,
        name: "Travelsphere",
        email: ""
    },
    5: {
        id: 5,
        name: "GEEO",
        email: "experience@gadventures.com"
    },
    13: {
        id: 13,
        name: "TruTravels",
        email: "info@trutravels.com"
    },
    16: {
        id: 16,
        name: "Smithsonian Journeys",
        email: "smithsonianjourneys@gadventures.com"
    }
};

var isGTBookingCompany = exports.isGTBookingCompany = function isGTBookingCompany(bookingCompanyId) {
    return bookingCompanyId === 3 || bookingCompanyId === 4;
};


//////////////////
// WEBPACK FOOTER
// ./app/utils/bookingCompanies.js
// module id = 125
// module chunks = 0